import React from "react";
import {
  ContactForm as ContactFormComponent,
  getPathname,
} from "@italymondo/core-ui";
import { useStaticContactFormQuery } from "./query";

export function ContactForm(): React.ReactElement | null {
  const data = useStaticContactFormQuery();

  if (!data) {
    return null;
  }

  return (
    <ContactFormComponent
      confirmationPageUrl={
        getPathname(
          data.site?.serviceIndexPage[0]?.footerContactForm?.confirmationPage
            ?.url
        ) || "/"
      }
      description={
        data.site.serviceIndexPage[0].footerContactForm.description || ""
      }
      sectionName={data.site?.serviceIndexPage[0].contactFormSectionName || ""}
      title={data.site.serviceIndexPage[0].footerContactForm.title || ""}
    />
  );
}
